import { FC, memo, useState } from 'react';

import Link from 'next/link';

import 'swiper/css';

import { useRecoilValue, useSetRecoilState } from 'recoil';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { cvPointAtom } from '@recoil_iqfu/atoms/public/cv_point';
import { sellerIsLoggedIn } from '@recoil_iqfu/atoms/public/login_state';

import styles from './CommonCTA.module.scss';

type Props = {
  hasTopPageLink?: boolean;
  internalLink?: {
    path: string;
    text: string;
  };
  withYellowBackground?: boolean;
  slideImages: string[];
  leadText: string;
  ctaLinkText: string;
  isFirstView?: boolean;
};

const CommonCTA: FC<Props> = memo(
  ({
    hasTopPageLink = false,
    internalLink,
    withYellowBackground = true,
    slideImages,
    leadText,
    ctaLinkText,
    isFirstView = false,
  }) => {
    const isLoggedIn = useRecoilValue(sellerIsLoggedIn);
    const [prevEl, setPrevEl] = useState<HTMLElement | null>(null);
    const [nextEl, setNextEl] = useState<HTMLElement | null>(null);
    const setCvPoint = useSetRecoilState(cvPointAtom);

    return (
      <div className={`${withYellowBackground ? styles.with_background : ''} ${styles.container}`}>
        <div className={styles.lead_container}>
          <p className={styles.lead_text}>{leadText}</p>
        </div>
        <div className={styles.slide_area_container}>
          <Swiper
            modules={[Navigation]}
            navigation={{
              prevEl,
              nextEl,
            }}
            threshold={10}
            slidesPerView={1.1}
            spaceBetween={4}
            centeredSlides={true}
            breakpoints={{
              600: {
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 8,
                centeredSlides: false,
              },
            }}
          >
            {slideImages.map((image, index) => (
              <SwiperSlide key={index}>
                <img
                  className={styles.cta_slide_image}
                  src={image}
                  alt=""
                  loading={isFirstView && index === 0 ? 'eager' : 'lazy'}
                />
              </SwiperSlide>
            ))}
          </Swiper>
          <div ref={(node) => setPrevEl(node)} className={styles.slider_prev}></div>
          <div ref={(node) => setNextEl(node)} className={styles.slider_next}></div>
        </div>

        <div className={styles.cv_button_area_container}>
          <div className={styles.cv_button_area}>
            {internalLink?.path && internalLink?.text && (
              <Link
                href={internalLink?.path}
                className={styles.cv_companies_link}
                dangerouslySetInnerHTML={{
                  __html: internalLink?.text,
                }}
              ></Link>
            )}

            <Link
              href={isLoggedIn ? '/chat/talk?redirect=contact' : '/signup_inquiry'}
              className={styles.cv_chat_link}
              onClick={() => {
                setCvPoint('CTA');
              }}
            >
              {ctaLinkText}
            </Link>

            {hasTopPageLink && (
              <Link href={'/'} className={styles.top_page_link}>
                イクラ不動産トップへ
              </Link>
            )}
          </div>
        </div>
      </div>
    );
  },
);

CommonCTA.displayName = 'CommonCTA';

export default CommonCTA;
